import * as PropTypes from 'prop-types';
import * as React from 'react';
import CheckboxFilterList from './checkbox_filter_list';
import SingleFilterList from './single_filter_list';
import PriceFilter from './price_filter';
import Trait from '../../taxonomy/trait';
import Category from '../../taxonomy/category';

const operatingSystem = Trait.findByUuid('c6639f61-8884-45e2-9f78-9f1de059700b');
const fileType = Trait.findByUuid('2ae386f1-7144-4d0c-b8aa-6caba14faa6f');

class IndexSidebar extends React.Component {
  static propTypes = {
    indexParams: PropTypes.object.isRequired,
    facets: PropTypes.object.isRequired,
  };

  hasFacets = facets => facets && facets.length > 0;

  showRefineResults = () => this.hasFacets(this.props.facets.brand) ||
      this.hasFacets(this.props.facets.operating_system) ||
      this.hasFacets(this.props.facets.file_type);

  renderCategories = () => (
    <div className="facet-container">
      <div className="facet__heading">
        {I18n.t('digitalProductsIndex.categories')}
      </div>
      <SingleFilterList
        className="strong"
        facets={this.props.facets.category}
        selected={this.props.indexParams.categorySlug}
        onChange={slug => this.props.indexParams.changeCategory(slug)}
        getValue={facet => Category.findByUuid(facet.value).slug}
        getName={facet => Category.findByUuid(facet.value).name}
        name="category"
      />
    </div>
  );

  renderBrands = () => {
    if (!this.hasFacets(this.props.facets.brand)) {
      return false;
    }

    return (
      <div className="facet">
        <div className="facet__heading">
          {I18n.t('digitalProductsIndex.brand')}
        </div>
        <CheckboxFilterList
          facets={this.props.facets.brand}
          selected={this.props.indexParams.brand || []}
          onChange={brands => this.props.indexParams.changeBrands(brands)}
          name="brand"
        />
      </div>
    );
  };

  renderOperatingSystems = () => {
    if (!this.hasFacets(this.props.facets.operating_system)) {
      return false;
    }

    return (
      <div className="facet">
        <div className="facet__heading">
          {I18n.t('digitalProductsIndex.operatingSystem')}
        </div>
        <SingleFilterList
          facets={this.props.facets.operating_system}
          selected={this.props.indexParams.operatingSystem}
          onChange={os => this.props.indexParams.changeOperatingSystem(os)}
          getValue={facet => operatingSystem.findValueByUuid(facet.value).slug}
          getName={facet => operatingSystem.findValueByUuid(facet.value).name}
          name="os"
        />
      </div>
    );
  };

  renderFileTypes = () => {
    if (!this.hasFacets(this.props.facets.file_type)) {
      return false;
    }

    return (
      <div className="facet">
        <div className="facet__heading">
          {I18n.t('digitalProductsIndex.fileType')}
        </div>
        <CheckboxFilterList
          facets={this.props.facets.file_type}
          selected={this.props.indexParams.fileTypes || []}
          onChange={fileTypes => this.props.indexParams.changeFileTypes(fileTypes)}
          getValue={facet => fileType.findValueByUuid(facet.value).slug}
          getName={facet => fileType.findValueByUuid(facet.value).name}
          name="file_type"
        />
      </div>
    );
  };

  renderPrice = () => (
    <PriceFilter
      priceMin={this.props.indexParams.priceMin}
      priceMax={this.props.indexParams.priceMax}
      priceChanged={(prices) => { this.props.indexParams.changePriceFilter(prices); }}
    />
  );

  renderRefineResults = () => {
    if (!this.showRefineResults()) {
      return false;
    }

    return (
      <div className="facet-container">
        {this.renderBrands()}
        {this.renderOperatingSystems()}
        {this.renderFileTypes()}
        {this.renderPrice()}
      </div>
    );
  };

  render() {
    return (
      <div className="mobile-d-none">
        {this.renderCategories()}
        {this.renderRefineResults()}
      </div>
    );
  }
}

export default IndexSidebar;



// WEBPACK FOOTER //
// ./javascripts/components/digital_listings/index_page/index_sidebar.jsx